import GlobalStyleComponent from "/var/www/www2.studioemma.com/versions/d6af33e6bcc38f0a781e495824e02f223e32867b/src/styles/global/GlobalStylesHandler";
export default GlobalStyleComponent;
